import React, { useState, useEffect } from "react";
import dataService from "../../services/dataService";
import CloseIcon from '@mui/icons-material/Close';
import { CartItemRequest } from "../../models/product/types";
import { LoadingStatusEnum } from "@/enums/loadingStatusEnum";
import { LinearProgress } from "@mui/material";

interface SidebarQuotedOrderProps {
  productId: number,
  quantity: number,
  uomId: number,
  name: string | null,
  sku: string | null,
  availability: string | null,
  imgUrl: string,
  mainPictureOverlay: string | null,
  open: boolean;
  onClose: (createdListId?: string) => void;
}

export const SidebarQuotedOrder: React.FC<SidebarQuotedOrderProps> = ({
  productId,
  quantity,
  uomId,
  name,
  sku,
  availability,
  imgUrl,
  mainPictureOverlay, open, onClose }) => {

  const [savedMessage, setSavedMessage] = useState("");
  const [linkMessage, setLinkMessage] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [quotedOrders, setQuotedOrders] = useState<{ id: number; jobNo: string }[]>([]);
  const [selectedId, setSelectedId] = useState<string>("");
  const [loadingStatus, setLoadingStatus] = useState<LoadingStatusEnum>(LoadingStatusEnum.IDLE);

  useEffect(() => {
    const GetQuotesOrderItems = async () => {
      setLoading(true);
      const result = await dataService.getQuotedOrders();
      const preselectedId = localStorage.getItem('selectedQuoteId');

      if (result && result.length > 0) {
        if (preselectedId) {
          const preselectedItem = result.find(
            item => item.id.toString() === preselectedId
          );

          if (preselectedItem) {
            setQuotedOrders([preselectedItem]);
            setSelectedId(preselectedId);
          } else {
            setQuotedOrders(result);
            setSelectedId(result[0].id.toString());
          }
        } else {
          setQuotedOrders(result);
          setSelectedId(result[0].id.toString());
        }
      } else {
        setQuotedOrders([]);
      }
      setLoading(false);
    };

    if (open) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      GetQuotesOrderItems();
    }
  }, [open]);

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLoadingStatus(LoadingStatusEnum.IDLE);
    setSelectedId(e.target.value);
  };

  const addProductToQuotedOrder = async (quoteId: string) => {
    const item: CartItemRequest =
    {
      productId: productId,
      attributeValueId: uomId,
      quantity: quantity
    };

    try {
      setLoadingStatus(LoadingStatusEnum.LOADING);
      const response = await dataService.AddProductToQuotedOrder(quoteId, item);
      
      if (response?.success) {
        setLoadingStatus(LoadingStatusEnum.SUCCESS);
        setSavedMessage("Succesfully Added");
        setLinkMessage(`${process.env.REACT_APP_WEB_URL}/Order/EditQuote?quoteId=${selectedId}`);
      }
      else {
        setLoadingStatus(LoadingStatusEnum.ERROR);
        alert(response?.message);
      }
    } catch (error) {
      setLoadingStatus(LoadingStatusEnum.ERROR);
      alert(error);
    }
  };

  return (
    <div>
      <div className={`sidebarAddNewListContainer sidebar ${open && !loading ? 'open' : ''}`}>
        <div className="sidebarClose" onClick={() => onClose()}>
          <CloseIcon/>
        </div>
        <div className="sidebarAddNewListBody sidebarBody">
          <h3 className="title">Add to Quoted Order</h3>
          <div className="sidebarProductinfo">
            <div className="sidebarImageHolder">
              <img alt="Product Placeholder" src={imgUrl} style={{ backgroundColor: mainPictureOverlay ?? "" }} />
            </div>
            <div className="sidebarInfoHolder">
              <h3 className="sidebarInfo">{name}</h3>
              <div className="sidebarInfo">{availability}</div>
              <div className="sidebarInfo" style={{ paddingTop: '3px' }}><strong style={{ marginRight: "3px" }}>SKU:</strong>{sku}</div>
            </div>
          </div>

          <div className="sidebarActions">
            <label className="sidebarActionsLabel">Select quote:</label>

            <select className="dropdown handCursor" value={selectedId} onChange={handleDropdownChange}>
              {quotedOrders.map((qutoe) => (
                <option key={qutoe.id} value={qutoe.id}>
                  {qutoe.jobNo || `#${qutoe.id}`}
                </option>
              ))}
            </select>
            {savedMessage && (
              <div style={{ marginLeft: "10px", marginTop: "0.5em", color: "#29b05f", fontWeight: "bold" }}>
                <span style={{marginLeft:"20px"}}>{savedMessage}</span> 
                {linkMessage && (
                  <>
                    <br />
                    <a href={linkMessage} style={{ textDecoration: "none", color: "#54afe2" }} >
                      Open Edit Quote Page
                    </a>
                  </>
                )}
              </div>
            )}
            <div className="buttons" style={{ textAlign: "right" }}>
              { LoadingStatusEnum.LOADING === loadingStatus ? <div style={{marginTop: "25px"}}><LinearProgress/></div> : 
              <button 
                disabled={loadingStatus === LoadingStatusEnum.SUCCESS}
                className="handCursor blueButtonOutline" 
                onClick={() => addProductToQuotedOrder(selectedId)}>
                Save
              </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SidebarQuotedOrder;
